import { useState } from 'react'
import { ArrowRight, Check } from 'lucide-react'

export default function SignupForm({ testIdPrefix, id }) {
  const [email, setEmail] = useState('')
  const [state, setState] = useState('idle')
  const [msg, setMsg] = useState('')

  const submit = async (e) => {
    e.preventDefault()
    if (state === 'loading') return
    setState('loading')
    setMsg('')
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/early-access`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      const data = await res.json()
      if (!res.ok) {
        setState('error')
        setMsg(data.detail || "Couldn't sign you up. Mind trying again?")
        return
      }
      setState('success')
      setMsg(data.count > 1 ? `${data.message} You're #${data.count} on the list.` : data.message)
    } catch {
      setState('error')
      setMsg("Couldn't reach us. Check your connection and try again?")
    }
  }

  const buttonId = `${testIdPrefix}-notify-button`
  const inputId = `${testIdPrefix}-email-input`

  return (
    <div className="w-full">
      {state === 'success' ? (
        <div
          className="pill-field !justify-between max-w-md mx-auto"
          data-testid={`${testIdPrefix}-signup-success`}
          role="status"
        >
          <span className="flex items-center gap-2.5 pl-0.5 text-[0.95rem]">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-[#B1C9E8]">
              <Check size={13} strokeWidth={3} className="text-ink" />
            </span>
            <span className="pr-2" data-testid={`${testIdPrefix}-signup-success-message`}>{msg}</span>
          </span>
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row items-stretch gap-3 max-w-md mx-auto" id={id} noValidate>
          <div className="pill-field flex-1">
            <input
              id={inputId}
              data-testid={inputId}
              type="email"
              required
              value={email}
              onChange={(e) => {
                setEmail(e.target.value)
                if (state === 'error') setState('idle')
              }}
              placeholder="Your email address"
              aria-label="Your email address"
              className="pill-input"
              autoComplete="email"
            />
          </div>
          <button type="submit" className="btn-ink justify-center" data-testid={buttonId} disabled={state === 'loading'}>
            {state === 'loading' ? 'One sec…' : 'Keep Me Posted'}
            <ArrowRight size={15} strokeWidth={2.2} className="transition-transform duration-500 group-hover:translate-x-0.5" />
          </button>
        </form>
      )}
      <p
        className={`mt-3.5 min-h-[1.25rem] text-center text-[0.82rem] transition-opacity duration-500 ${
          state === 'error' ? 'text-[#C24A2B] opacity-100' : state === 'success' ? '' : 'text-haze opacity-70'
        }`}
        data-testid={`${testIdPrefix}-form-message`}
        role={state === 'error' ? 'alert' : undefined}
      >
        {state === 'error' ? msg : state === 'success' ? '' : msg}
      </p>
    </div>
  )
}
